module.exports = __webpack_public_path__ + "static/media/VV 16-21.8cabf14a.mp3";